// NGRX
import { select, Store } from '@ngrx/store';
// CRUD
import { BaseDataSource } from '../../_base/crud';
// State
import { AppState } from '../../reducers';

import {
  selectMedReview,
  selectMedReviewInitWaitingMessage,
  selectMedReviewLoading,
} from '../../../views/pages/med-review/selectors/med-review.selectors';

export class MedReviewDatasource extends BaseDataSource {
  constructor(private store: Store<AppState>) {
    super();

    this.loading$ = this.store.pipe(select(selectMedReviewLoading));

    this.isPreloadTextViewed$ = this.store.pipe(select(selectMedReviewInitWaitingMessage));

    this.store.pipe(select(selectMedReview)).subscribe((response: any) => {
      this.paginatorTotalSubject.next(response.totalCount);
      this.entitySubject.next(response.items);
    });
  }
}
